import {Values} from "../common-types/common-types";

export const HtmlTextDirection = {
    Ltr: 'ltr',
    Rtl: 'rtl',
    Auto: 'auto',
} as const;

export type HtmlTextDirection = Values<typeof HtmlTextDirection>;